import React, { useState } from 'react';
import classNames from 'classnames';
import filterIcon from '../../../assets/images/filters.svg';
import filterArrow from '../../../assets/images/filter-arrow.svg';
import useMediaQuery, { MOBILE_WIDTH_QUERY } from '../../../components/hooks/useMediaQuery';

import './FiltersContainer.scss';

/**
 * FiltersContainer component for managing and displaying filters.
 *
 * @component
 * @param {object} props - The component props.
 * @param {number} props.filterCount - The count of active filters.
 * @param {Function} props.handleClearFilters - Function to clear filters.
 * @param {React.ReactNode} props.filterCol - JSX for filtering by columns.
 * @param {React.ReactNode} props.filterSearchCaregiver - JSX for searching caregivers.
 * @returns {JSX.Element} The rendered component.
 */
const FiltersContainer = ({ filterCount, handleClearFilters, filterCol, filterSearchCaregiver }) => {
	const [isOpen, setIsOpen] = useState(true);
	const isMobile = useMediaQuery(MOBILE_WIDTH_QUERY);

	/**
	 * JSX for the desktop view of filters.
	 *
	 * @type {JSX.Element}
	 */
	const DesktopView = (
		<>
			<div className="filter-container">
				<button
					type="button"
					onClick={() => {
						setIsOpen(!isOpen);
					}}
					className={classNames('filter-btn-container', 'filter-btn', { noFilterCount: filterCount === 0 })}
				>
					<img src={filterIcon} alt="filters" />
					<div className="filter-text">Filters</div>
					{filterCount > 0 && <div className="filter-number">{filterCount}</div>}
					<img src={filterArrow} alt="expand" className={classNames('arrow-icon', { down: isOpen })} />
				</button>
				{filterCount > 0 && (
					<button type="button" onClick={handleClearFilters} className="filter-btn clear">
						Clear all
					</button>
				)}
			</div>

			{isOpen && (
				<div className="row no-gutters">
					{filterCol}
					<div className={classNames('col-xl-4 col-md-4', { 'search-professional-filter': isMobile })}>
						{filterSearchCaregiver}
					</div>
				</div>
			)}
		</>
	);

	return <div className="filter-shift-container">{DesktopView}</div>;
};

export default FiltersContainer;
